/**
 * 跨页去重(home/search/category feed)。按 productId 保序去重;
 * 空 productId 的脏数据跳过(home.md 边界:去重跳过)。
 */
import type { ProductFeedItem } from '@/api/guide';

export function dedupeById(items: ProductFeedItem[]): ProductFeedItem[] {
  const seen = new Set<string>();
  const out: ProductFeedItem[] = [];
  for (const it of items) {
    const id = it.productId;
    if (!id || seen.has(id)) continue;
    seen.add(id);
    out.push(it);
  }
  return out;
}
